import styled from 'styled-components';
import Popover from 'react-popover';

import {
  Flex,
  utils,
} from 'web-styled';

export const StyledPopover = styled(Popover)`
  & > .Popover-tip {
    fill: ${props => props.col || 'white'};
  }
`;

export const ExerciseOrder = styled(Flex).attrs({
  align: 'center',
  spacing: 15,
  flex: '0 0 62px',
  justify: 'space-between',
})`
  width: 100%;
  padding: 13px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.27);
  z-index: 9;
`;

export const OrderName = styled(Flex).attrs({
  align: 'center',
  flex: '0 0 30px',
})`
  display: block;
  padding: 0;
  border: 0 none;
  width: 30px;
  height: 30px;
  line-height: 30px;
  transition: background-color 0.3s ease;
  border-radius: 15px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
  position: relative;
  user-select: none;
  ${utils.exerciseColor};

  @media print {
    align-self: flex-start;
    background-color: #717171;
  }
`;

export const NumberContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  clickable: true,
})`
  color: #fff;
  text-transform: uppercase;
  border-radius: 50%;
  width: 41px;
  height: 41px;

  ${utils.exerciseColor};
`;

export const Add = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  clickable: true,
})`
  height: 41px;
  width: 41px;
  border-radius: 50%;
  border: 1px solid #c1c1c1;
  margin-left: 5px;

  &:before,
  &:after {
    content: '';
    display: block;
    background-color: #c1c1c1;
    position: absolute;
  }
  &:before {
    width: 16px;
    height: 2px;
  }
  &:after {
    width: 2px;
    height: 16px;
  }
`;
